module.exports = __webpack_public_path__ + "static/section-2-creator-l-b2a15dcc87c844b0985ff0739177451f.png";